import {
  forwardRef,
  MenuList as ChakraMenuList,
  MenuListProps as ChakraMenuListProps,
  usePrefersReducedMotion,
} from '@chakra-ui/react';

export type MenuListProps = ChakraMenuListProps;

const MenuList = forwardRef<MenuListProps, 'div'>((props, ref) => {
  const prefersReducedMotion = usePrefersReducedMotion({ ssr: false });
  return (
    <ChakraMenuList
      motionProps={
        prefersReducedMotion
          ? {
              variants: {
                enter: {
                  visibility: 'visible',
                  opacity: 1,
                  transition: {
                    duration: 0,
                  },
                },
                exit: {
                  transitionEnd: {
                    visibility: 'hidden',
                  },
                  opacity: 0,
                  transition: {
                    duration: 0,
                  },
                },
              },
            }
          : undefined
      }
      {...props}
      ref={ref}
    />
  );
});

export default MenuList;
